import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TenantChannelModel } from 'src/app/models/tenants/tenant-channel.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { LoadingService } from 'src/app/services/loading.service';
import { TenantChannelService } from 'src/app/services/tenants/tenant-channel.service';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-copy-invitation-link-modal',
  standalone: false,
  templateUrl: './copy-invitation-link-modal.component.html',
  styleUrl: './copy-invitation-link-modal.component.scss'
})
export class CopyInvitationLinkModalComponent implements OnInit {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Input() 
  trainingKey!: string;

  internalChannels: TenantChannelModel[] = [];
  externalChannels: TenantChannelModel[] = [];
  
  internalColumns: TableColumn[] = [
    {
      caption: '',
      dataField: 'name',
      cellValue: () => {
        return this.translateService.instant(
          'COPY-INVITATION-LINK.OVERVIEW.STANDARD-INVITATION-LINK'
        );
      },
    },
    {
      caption: '',
      dataField: 'this',
      cellType: 'action',
      disableFiltering: true,
      cellTemplate: 'actionsTemplate',
      actions: [
        {
          icon: 'copy',
          isShowAction: () => true,
          onClick: (channel: TenantChannelModel, e: any): void => {
            this.onCopyLinkClick(channel);
          },
        },
      ],
    },
  ];
  
  externalColumns: TableColumn[] = [
    {
      caption: '',
      dataField: 'name',
    },
    {
      caption: '',
      dataField: 'this',
      cellType: 'action',
      disableFiltering: true,
      cellTemplate: 'actionsTemplate',
      actions: [
        {
          icon: 'copy',
          isShowAction: () => true,
          onClick: (channel: TenantChannelModel, e: any): void => {
            this.onCopyLinkClick(channel);
          },
        },
      ],
    },
  ];
  
  constructor(
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private clipboard: Clipboard,
    private tenantChannelService: TenantChannelService,
  ){
    
  }
  
  ngOnInit() {
    this.loadingService.load(
      forkJoin({
        internalChannel: this.tenantChannelService.getInternalTenantChannel(),
        externalChannels: this.tenantChannelService.getExternalTenantChannels()
      })
    ).subscribe(({internalChannel, externalChannels}) => {
      this.internalChannels = [internalChannel];
      this.externalChannels = externalChannels;
    });
  }

  onCopyLinkClick(channel: TenantChannelModel): void {
    const base =
      window.location.origin +
      environment.myInvitationBaseUrl +
      '/' + this.trainingKey;

    const url = new URL(base);
    url.searchParams.set('channel', channel.token);

    if (this.clipboard.copy(url.toString())) {
      this.toastrService.success(
        this.translateService.instant(
          "COPY-INVITATION-LINK.LINK-SAVED-TO-CLICKBOARD"
        )
      );
    } else {
      this.toastrService.warning(
          this.translateService.instant(
          "COPY-INVITATION-LINK.LINK-NOT-SAVED-TO-CLICKBOARD"
        )
      );
    }
  }

  onClose = () => {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };
}
